import InlineLinkLists from "./InlineLinkLists";
import LogosRow from "./LogosRow";
import classnames from 'classnames';
import { jsx as _jsx, jsxs as _jsxs } from "preact/compat/jsx-runtime";
/**
 * For information about how and when to use this component,
 * [refer to its full documentation page](https://design.cms.gov/components/footer/healthcare-footer/?theme=healthcare).
 */
export const Footer = props => {
  const classes = classnames('hc-c-footer', props.className);
  return /*#__PURE__*/_jsxs("footer", {
    className: classes,
    role: "contentinfo",
    children: [props.footerTop, /*#__PURE__*/_jsx(InlineLinkLists, {
      primaryDomain: props.primaryDomain
    }), /*#__PURE__*/_jsx(LogosRow, {
      logoClassName: props.logoClassName
    })]
  });
};
export default Footer;